import Vue from 'vue'
import App from "./App.vue";
import router from './routes.js'
import mui from "./assets/css/mui-0.9.36/css/mui.css";
import "./assets/css/mui-0.9.36/extra/mui-colors.css";
import "./assets/css/fontawesome-all.css";

new Vue({
  el: "#app",
  router: router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js